import { FC, useContext } from "react";
import { TableViewContainer } from "../../../../shared/components/tableViewContainer";
import DataTable from "../../../../shared/components/dataTable";
import SearchBox from "../../../../layouts/SidebarLayout/Header/SearchBox";
import { useNavigate } from "react-router-dom";
import useQuery from "../../../../shared/components/hooks/useQuery";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import NoPermissionContent from "../../../../shared/components/noPermissionBanner";
import Loader from "../../../../shared/components/loader/linearProgress";
import { Reseller } from "../../../../shared/interfaces/reseller";

const ResellerList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);
  const navigateToDetails = () => {
    navigate("/resellers/create");
  };
  const { loading, data, error } = useQuery("/admin/organization", {
    params: {
      ...payload,
    },
  });
  const resellerData = data as any;
  let resellerList: Reseller[] = [];
  resellerList = (data as any)?.items?.map((reseller: any) => {
    return {
      id: reseller.id,
      name: reseller?.name,
      phone: reseller?.organizationProfile?.phone,
      email: reseller?.organizationProfile?.email,
      domainName: reseller?.subdomainName,
    };
  });

  const titleBarNode = <SearchBox />;
  const resellertitleBar = {
    title: "Resellers",
    buttonTitle: "Create",
    titleBarNodes: titleBarNode,
    onClick: navigateToDetails,
    disabled:  resellerData?.entityPermissions
    ? !resellerData?.entityPermissions?.includes("Reseller-Create")
    : false,
    subHeading: "",
    rowCount: resellerData?.totalItems,
  };

  const resellerDisplayColumns = ["name", "email", "phone", "domainName"];

  return (
    <TableViewContainer titleBar={resellertitleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Reseller"
          data={resellerList}
          displayColumns={resellerDisplayColumns}
          linkColumn="name"
          linkUrl="/resellers"
          pagination={{ take: 25, skip: 0 }}
          setPagination={setPayload}
          totalItems={resellerData?.totalItems}
        />
      )}
    </TableViewContainer>
  );
};

export default ResellerList;
